import { render, staticRenderFns } from "./CallLogProfile.vue?vue&type=template&id=632bc61c&"
import script from "./CallLogProfile.vue?vue&type=script&lang=js&"
export * from "./CallLogProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports